import React, { FC, PropsWithChildren, useEffect, useMemo, useState } from 'react'
import {
  ColFields,
  DataTableCNHComponentProps,
} from './types/DataTableCNHComponent.types'
import './DataTableCNHComponent.scss'
import { Image, RichText } from '@sitecore-jss/sitecore-jss-react'

const DataTableCNHComponent: FC<DataTableCNHComponentProps> = ({
  fields,
}) => {

  const [hasImages, updateHasImages] = useState<boolean>(false);
  const [colItemsList, updateColItemsList] = useState<ColFields[]>([]);

  useEffect(() => {
    const colItems: ColFields[] = [];
    fields?.Lists.forEach(item => {
      item.fields.Lists.forEach((colItem) => {
        colItems.push(colItem.fields);
      });
    });
    updateColItemsList(colItems);
    updateHasImages(colItems?.every(item => (item?.Image?.value?.src?.length ?? 0) > 0));
  }, [fields]);

  const RowComponent: FC<
    PropsWithChildren<{ isContrast: boolean; isHeader: boolean }>
  > = useMemo(() => {
    
    return function Component({ isContrast, isHeader, children }) {
      const _className = useMemo(
        () =>
          `DataTableCNHComponent__row ${
            isHeader ? 'DataTableCNHComponent__row--header' : ''
          } ${
            !isHeader && isContrast
              ? 'DataTableCNHComponent__row--contrast'
              : ''
          }`,
        [isContrast, isContrast]
      )

      return <div className={_className}>{children}</div>
    }
  }, [])

  const ColumnComponent: FC<{ fields: ColFields }> = useMemo(() => {
    return function Component({
      fields: { Image: image, Title: title, Subtitle: subtitle },
    }) {
      const isImage = useMemo(() => (image.value?.src?.length ?? 0) > 0, [Image])

      return (
        <div className="DataTableCNHComponent__col">
          {isImage ? (
            <Image field={image} />
          ) : (
            <div>
              <RichText field={title} />
              <RichText
                className="DataTableCNHComponent__col_subtitle"
                field={subtitle}
              />
            </div>
          )}
        </div>
      )
    }
  }, [])

  if (hasImages) {
    return (
      <div className="DataTableCNHComponent__wrapper">
        <div className='DataTableCNHComponent__image-row'>
          {
            colItemsList.map(list => {
              return (
                <div className="DataTableCNHComponent__col">
                  <Image field={list.Image} />
                </div>
              )
            })
          }
        </div>
      </div>
    )
  }

  return (
    <div className="DataTableCNHComponent">
      {fields?.Lists.map(
        (
          {
            fields: {
              Header: { value: isHeader },
              Lists: columnsList,
            },
          },
          idx
        ) => (
          <RowComponent
            key={idx}
            isHeader={isHeader}
            isContrast={idx % 2 === 0}
          >
            {columnsList.map(({ fields: colFields }) => (
              <ColumnComponent fields={colFields} />
            ))}
          </RowComponent>
        )
      )}
    </div>
  )
}

export default DataTableCNHComponent
